import {useEffect, useRef} from "react"
import {useTranslation} from "react-i18next"
import {useEcpWorkflowContext} from "../../reactContext/contextCustomHooks/useEcpWorkflowContext"
import AddGlossaryTermModalForm from "../../forms/glossary/AddGlossaryTermModalForm"
import UpdateGlossaryTermModalForm from "../../forms/glossary/UpdateGlossaryTermModalForm"
import closeIcon from "../../assets/icon/close.svg"
import useClickOutside from "../../tools/useClickOutside"
import ScrollingMod from "../../tools/ScrollingMod"

export default function GlossaryModal({type}) {
    const {t} = useTranslation()
    const {setEcpWorkflowAction} = useEcpWorkflowContext()
    const glossaryModalModalRef = useRef(null)

    const closeModal = () => {
        setEcpWorkflowAction({type: "CLEAN_ECP_WORKFLOW_CONTEXT"})
        ScrollingMod(false)
    }

    useClickOutside(glossaryModalModalRef, () => {
        closeModal()
    })

    useEffect(() => {
        window.scrollTo(0, 0)
        ScrollingMod(true)
    }, [])

    return (
        <>
        <div ref={glossaryModalModalRef} className="_SECTION GLOSSARY-MODAL">
            <h3>{type === "add" ? t("Add a term") : t("Term update")}</h3>
            <img className="close" src={closeIcon} alt="" onClick={closeModal}/>
            {type === "add" ? <AddGlossaryTermModalForm closeModal={closeModal}/> : <UpdateGlossaryTermModalForm closeModal={closeModal}/>}
        </div>
        </>
    )
}